import React, { Component } from 'react';

class ReleaseNotesList extends Component {
	render() {
		const { releaseNotes } = this.props;

		return <ul>
			{releaseNotes.map(item => {
				const isNew = item.status === 'new';

				return <li key={item.title}>
					<div className='clearfix' />
					<div>
						<span className='author'>{item.title} {isNew && <span className='badge badge-danger'>new</span>}</span>
						<div className='preview' dangerouslySetInnerHTML={{ __html: item.notes }} />
					</div>
				</li>;
			})}
		</ul>;
	}
}

export default ReleaseNotesList;